import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { fmt } from '../../utils/format';

const Icon = ({ d, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

const ICONS = {
  dashboard: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
  quotes:    'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  customers: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0',
  catalog:   'M4 6h16M4 10h16M4 14h16M4 18h16',
  admin:     'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
  executive: 'M3 3v18h18M7 16l4-5 3 3 5-7',
  cortes:    'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
  logout:    'M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1',
  manual:    'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
};

export default function Sidebar() {
  const { user, logout, isManager, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <h1>Magnolia</h1>
        <span>Windows &amp; Doors</span>
      </div>

      <nav className="sidebar-nav">
        {isManager && (
          <>
            <div className="nav-section-label">Overview</div>
            <NavLink to="/dashboard" className={({isActive}) => `nav-link${isActive?' active':''}`}>
              <Icon d={ICONS.dashboard} /> Dashboard
            </NavLink>
            <NavLink to="/executive" className={({isActive}) => `nav-link${isActive?' active':''}`}>
              <Icon d={ICONS.executive} /> Ejecutivo
            </NavLink>
            {/* 'end' para que Comisiones no se quede marcado estando en Cortes */}
            <NavLink to="/commissions" end className={({isActive}) => `nav-link${isActive?' active':''}`}>
              <Icon d={ICONS.executive} /> Comisiones
            </NavLink>
            <NavLink to="/commissions/runs" className={({isActive}) => `nav-link${isActive?' active':''}`}>
              <Icon d={ICONS.cortes} /> Cortes
            </NavLink>
          </>
        )}

        <div className="nav-section-label">Sales</div>
        <NavLink to="/quotes" className={({isActive}) => `nav-link${isActive?' active':''}`}>
          <Icon d={ICONS.quotes} /> Quotes
        </NavLink>
        <NavLink to="/customers" className={({isActive}) => `nav-link${isActive?' active':''}`}>
          <Icon d={ICONS.customers} /> Customers
        </NavLink>

        {isManager && (
          <>
            <div className="nav-section-label">Catalog</div>
            <NavLink to="/catalog" className={({isActive}) => `nav-link${isActive?' active':''}`}>
              <Icon d={ICONS.catalog} /> Products &amp; Prices
            </NavLink>
          </>
        )}

        {isAdmin && (
          <>
            <div className="nav-section-label">Admin</div>
            <NavLink to="/admin/users" className={({isActive}) => `nav-link${isActive?' active':''}`}>
              <Icon d={ICONS.admin} /> Users &amp; Settings
            </NavLink>
            <NavLink to="/admin/odoo" className={({isActive}) => `nav-link${isActive?' active':''}`}>
              <Icon d={ICONS.admin} /> Odoo Integration
            </NavLink>
          </>
        )}

        {/* Los manuales viven en public/manuales y son archivos estaticos, no
            pantallas de React. Por eso va <a> y no NavLink: una ruta de React
            cae al catch-all de App.js y manda al usuario a Quotes. Se abre en
            pestana nueva para que no pierda la cotizacion que trae abierta. */}
        <div className="nav-section-label">Ayuda</div>
        <a href="/manuales/" target="_blank" rel="noopener noreferrer" className="nav-link">
          <Icon d={ICONS.manual} /> Manuales
        </a>
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="user-avatar">{fmt.initials(user?.name)}</div>
          <div className="user-info">
            <div className="user-name">{user?.name}</div>
            <div className="user-role">{user?.role}</div>
          </div>
          <button className="btn btn-icon btn-ghost" onClick={handleLogout} title="Logout">
            <Icon d={ICONS.logout} size={14} />
          </button>
        </div>
      </div>
    </aside>
  );
}
